//--------------------------------------------------
// imported classes
//--------------------------------------------------
const Common = require('@/tbs/model/to/Common')
const ClassFunc = require('@/tbs/util/ClassFunc')

/**
 * The Player class works as the player translator.
 */
const tbs_model_to_MatchEntry = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Common, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_to_MatchEntry.prototype = {
    'match-entry': '赛事入驻',
    'organization-total': '入驻机构',
    'match-total': '办赛数量',
    'member-total': '辐射的人群',
    'feature-intro': '功能介绍',
    'new-feature': '新功能',
    'new-feature-title-01': '本月最新更新',
    'new-feature-content-01': '支持多种赛事报名收费方式，组委会统一在线采购保险，新版赛事页面更新上线',
    'new-feature-title-02': '上月更新',
    'new-feature-content-02': '支持多种赛事报名收费方式，组委会统一在线采购保险，新版赛事页面更新上线',
    'new-feature-title-03': '25年3月',
    'new-feature-content-03': '支持多种赛事报名收费方式，组委会统一在线采购保险，新版赛事页面更新上线',
}

//--------------------------------------------------
// extends the Common
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_MatchEntry, Common);

module.exports = tbs_model_to_MatchEntry